module.exports = __webpack_public_path__ + "media/packs/images/flags/MQ-3f117d7e60c51b7a9e170aa014e67d9a.png";